import { FC } from 'react'
import cn from 'clsx'
import { Button } from '@components/ui'

interface Props {
  product: {
    name: string
    description: string
    path: string
    price: {
      value: string
      currencyCode: string
    }
    images: Array<{ url: string; altText: string }>
    variants: Array<{
      name: string
      price: string
      listPrice: string
      availableForSale: boolean
    }>
  }
  addToCart: (product: any) => any
}

const ns = `cart-recommended-products-card`

const Card: FC<Props> = ({ product, addToCart }) => {
  const rootClassNames = cn({
    [`${ns}`]: true,
  })

  const { name, price, path, variants = [null], images = [null] } = product
  const [variant] = variants
  const [image] = images
  const description = `2,500mcg | 120 Softgels` // TODO replace with actual description

  /**
   * Custom format function that takes a price string and currency code
   * and formats them into a desired price format. Will return null if
   * the amount has yet to be calculated / rendered.
   *
   * @param amount | Pre-formatted price amount
   * @param currencyCode | Product currency string
   * @param locale | Locale string
   * @returns A formatted price string with the desired currency
   */
  const formatPrice = (
    amount?: any | undefined | null,
    currencyCode?: any | undefined | null,
    locale?: any | undefined | null
  ) => {
    if (!amount || !currencyCode) return null

    const formatCurrency = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
    })

    return formatCurrency.format(amount)
  }

  const formattedPrice =
    variant &&
    formatPrice(
      variant?.listPrice || variant?.price || price?.value,
      price?.currencyCode
    )

  return (
    <div className={rootClassNames}>
      <div className={`${ns}__container`}>
        <div className={`${ns}__wrapper ${ns}__wrapper-media`}>
          {path && image?.url && (
            <a href={`/products${path}`}>
              <div className={`${ns}__media`}>
                <img
                  src={image.url}
                  alt={image?.altText || name || `product ${path}`}
                  height={125}
                  width={125}
                />
              </div>
            </a>
          )}
        </div>
        <div className={`${ns}__wrapper ${ns}__wrapper-content`}>
          {name && <div className={`${ns}__name`}>{name}</div>}
          <div className={`${ns}__subwrapper`}>
            {description && (
              <div className={`${ns}__description`}>{description}</div>
            )}
            {variant?.name && (
              <div className={`${ns}__description`}>{variant.name}</div>
            )}
          </div>
        </div>
        <div className={`${ns}__wrapper ${ns}__wrapper-price`}>
          {formattedPrice && (
            <div className={`${ns}__price`}>{formattedPrice}</div>
          )}
          {variant?.availableForSale && (
            <Button
              variant={`outline-black`}
              size={`sm`}
              className={`${ns}__cta`}
              onClick={() => addToCart(product)}
            >
              ADD
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Card
